import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/srcIncidentsLinkedServicesQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const incidentsPageEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-incidents-page" */ './src').then(
			(mod) => mod.IncidentsPageLinkedServicesWrapper,
		),
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context }: EntryPointRouteParams) => ({
		queries: {
			incidentPageData: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId,
					projectKey: context.match.params.projectKey ?? '',
				},
			},
		},
	}),
});
